import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';
import { useShipmentFormStore } from '@/stores/useShipmentFormStore';

/**
 * Keeps `generalPlannedRange` in sync with first-stop departure and last-stop arrival.
 */
export function useShipmentFormPlannedRangeSync() {
  const formStore = useShipmentFormStore();
  const { generalPlannedRange, stops } = storeToRefs(formStore);

  const syncing = ref(false);

  watch(
    generalPlannedRange,
    () => {
      if (syncing.value) return;
      syncing.value = true;
      formStore.applyGeneralPlannedRangeToAnchorStops();
      syncing.value = false;
    },
    { deep: true },
  );

  watch(
    () => {
      const rows = stops.value;
      if (rows.length < 2) return null;
      return [
        rows[0]!.plannedDeparture?.getTime() ?? null,
        rows[rows.length - 1]!.plannedArrival?.getTime() ?? null,
      ] as const;
    },
    () => {
      if (syncing.value) return;
      syncing.value = true;
      formStore.syncGeneralPlannedRangeFromStops();
      syncing.value = false;
    },
  );
}
